var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessengerLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "url(#paint0_linear_58_155523)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1484 26.4482C16.1484 20.6787 20.6687 16.4072 26.5 16.4072C32.3313 16.4072 36.8516 20.6787 36.8516 26.4482C36.8516 32.2178 32.3313 36.4893 26.5 36.4893C25.4526 36.4893 24.4477 36.351 23.5035 36.0913C23.32 36.0408 23.1248 36.0551 22.9507 36.1319L20.896 37.0389C20.3586 37.2762 19.7519 36.894 19.7339 36.3067L19.6775 34.4653C19.6706 34.2384 19.5685 34.0264 19.3994 33.8751C17.3852 32.0739 16.1484 29.4661 16.1484 26.4482ZM23.3244 24.5601L20.2836 29.3843C19.9918 29.8473 20.5609 30.369 20.9968 30.0382L24.2631 27.5593C24.4841 27.3916 24.7894 27.3907 25.0113 27.5571L27.4298 29.371C28.1555 29.9153 29.1913 29.7242 29.675 28.9568L32.7158 24.1325C33.0076 23.6695 32.4385 23.1478 32.0025 23.4786L28.7363 25.9575C28.5153 26.1252 28.21 26.1261 27.9881 25.9597L25.5696 24.1458C24.8439 23.6015 23.8081 23.7926 23.3244 24.5601Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_155523",
    x1: 26.5,
    y1: 0,
    x2: 26.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF626F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F7BFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerLg);
export default __webpack_public_path__ + "static/media/messenger-lg.96226048330bb0d0a88c4bf5d7b969c6.svg";
export { ForwardRef as ReactComponent };